<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'平台宣传管理'},{name:'平台宣传列表'}]" :title="'平台宣传列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">上架状态</span>
                        <el-select v-model="sendInfo.putawayStatus" placeholder="请选择" size="small" clearable>
                          <el-option label="全部" :value="void 0"></el-option>
							            <el-option label="已上架" :value="1"></el-option>
                          <el-option label="已下架" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">发布日期</span>
                        <el-date-picker
                         size="small"
						v-model="sendInfoOne.time"
                         format="yyyy-MM-dd"
						value-format="yyyy-MM-dd HH:mm:ss"
						type="datetimerange"
						:default-time="['24:00:00','23:59:59']"
                         range-separator="至"
                         start-placeholder="开始日期"
                         end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                  <el-button type="primary" size="small" @click="edit()" icon="el-icon-plus">发布视频</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                :default-sort="{prop: 'date'}"
                @sort-change="sortChange"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    label="排序">
                    <template slot-scope="scope">
                        <div class="elrow">
                            <i class="el-icon-top" v-if="scope.$index != 0  || (scope.$index === 0 && PageData.currentPage  !== 1)" @click="moveDown(scope.row,0)"></i>
                            <i class="el-icon-bottom" v-if="scope.$index != tableData.length - 1 || PageData.currentPage < totalPage" @click="moveDown(scope.row,1)"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    label="视频ID">
                </el-table-column>
                <el-table-column
                    prop="title"
                    show-overflow-tooltip
                    label="视频名称">
                </el-table-column>
                <el-table-column
                    prop="pageView"
                    show-overflow-tooltip
                    label="浏览量">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    label="上架状态">
                </el-table-column>
                <el-table-column
                    prop="userName"
                    show-overflow-tooltip
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="300">
                    <template slot-scope="scope">
                       <el-button size="small" type="primary" class="super" plain
                                    @click="check(scope.row)">查看</el-button>
                        <el-button  size="small" type="primary" class="super" plain
                                     @click="edit(scope.row)">编辑</el-button>
                                     
                        <el-button  size="small" :type="scope.row.putawayStatus===0?'success':'warning'" class="super" plain
                                     @click="soldOut(scope.row)" >{{scope.row.btnValue}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <Paging
                :PageData="PageData"
                v-if="tableData.length>0"
                @nextpage="nextpage"
                @previouspage="previouspage"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                ></Paging>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
			status:[],//上下架
            options: [{
                value: '1',
                label: '视频ID'
                }, {
                value: '2',
                label: '视频名称'
            }],//检索下拉
            sendInfoOne:{
                time:"",//日期
                drop:'',//检索下拉值
                dropValue:"",//检索输入值
            },//检索提交数据
            tableData:[],//表格数据
			sendInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
				property:void 0,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				serviceType:void 0,//服务状态
				status: void 0,//上下架状态
				id:void 0,//视频id
				userName:void 0,//账号
				name:void 0,// 视频名称
				endTime:void 0,//结束时间
				startTime:void 0,//开始时间
        putawayStatus: void 0 // 0=已下架，1=已上架
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
            totalPage: 0,
			dataInfo:'',//详细信息
			statusList:[],
      move:{
                id:'',
                move:''
            },
        }
    },
	created() {
		// getDict('UA_LS').then(data=>{
		//     this.status = data.UA_LS;
		// })
		// this.$axiosz.get('/rpc/sysDict/parentId/1069409909080064').then(res=>{
		//     if(res.code==200){
		// 		this.statusList=res.data
		//     }else{
		//         this.$alert(res.msg)
		//     }
		// })
		this.getList()
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 60
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 60
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      onReset(){
        this.sendInfoOne={
                time:"",//日期
                drop:'',//检索下拉值
                dropValue:"",//检索输入值
            }
        const param = {
          currentPage:1,//当前页
				pageSize:10,//页条数
				property:void 0,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				serviceType:void 0,//服务状态
				status: void 0,//上下架状态
				id:void 0,//视频id
				userName:void 0,//账号
				name:void 0,// 视频名称
				endTime:void 0,//结束时间
				startTime:void 0,//开始时间
        putawayStatus: void 0 // 0=已下架，1=已上架
        }
        this.sendInfo= Object.assign(this.sendInfo,param)
        if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
            if(this.$refs.table) this.$refs.table.clearSort()
        this.retrieval()
      },
      doLayout() {
      this.$nextTick(() => {
        if (this.$refs.table && this.$refs.table.doLayout) {
          this.$refs.table.doLayout()
        }
      })
    },
    // 表头样式回调
    headerStyle() {
      return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
    },
		getList(){
      this.loading = true
			this.$axiosc.get('/backstage/publicity/publicityList',{params:this.sendInfo}).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
                    this.totalPage = res.data.totalPage
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //查询
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startTime=lookData.time[0];
				this.sendInfo.endTime=lookData.time[1];
			}else {
                this.sendInfo.startTime=void 0;
                this.sendInfo.endTime=void 0;
            }
            this.sendInfo.id=void 0;
            this.sendInfo.name=void 0;
            switch(lookData.drop){
                case '1':
                  this.sendInfo.id=lookData.dropValue;
                break;
                case '2':
                  this.sendInfo.name=lookData.dropValue;
            }
			// 检索值
			this.getList()
		},
        //表格排序
        sortChange:function({ column, prop, order }){
            if (order == 'ascending') {
                    order = 'ASC';
                } else {
                    order = 'DESC';
                }
                this.sendInfo.property = prop;
                this.sendInfo.direction = order;
                this.getList();
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:`/platformManagement/detail/${row.id}`,query:{index:'/platformManagement'},params:{id:row.id}})
        },
        //发布 编辑
        edit:function(row){
            if(row){//编辑
                this.$router.push({path:`/platformManagement/edit/${row.id}`,query:{index:'/platformManagement'},params:{id:row.id}})
            }else{//发布
                this.$router.push({path:'/platformManagement/add',query:{index:'/platformManagement'}})
            }
        },
        //表格下架,上架按钮
        soldOut:function(row){
		    let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    const param = {
                        id:row.id,
                        putawayStatus:row.putawayStatus === 0?1:0
                    }
                    this.$axioscBody.post('/backstage/publicity/putawayPublicity',param).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            this.getList();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }).catch(() => {
            });
        },
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
          this.sendInfo.currentPage = val;
          this.getList()
        },
        moveDown:function(row,val){
            this.move.id = row.id
            this.move.move = val
            this.$axiosc.put('/backstage/publicity/moveUpDown',this.$qs.stringify(this.move)).then(res=>{
                if(res.code == 200){
                    this.getList()
                    this.$message({
                        type: 'success',
                        message: val == 0?'上移成功':'下移成功'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            })
        }
    },watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>
<style scoped="scoped" lang="scss" >
.main{
  height:calc(100% - 40px);
}
	.noclick{
		color: #DDDDDD;
		border: 1px solid #ddd;
    cursor:not-allowed;
    &:hover,&:active,&:focus{
      color:#DDDDDD;
      border: 1px solid #ddd;
    }
	}
</style>
